import { Country } from './country';
import countriesJson from "../../../countries.json";

export class Countries {

    public countries: Country[];
    public employerCountries: Country[];

    /**
     * Validate if country code exists
     * @param code 
     * @returns 
     */
    isValidCountryCode(code: string) {
        for (let i = 0; i < this.countries.length; i++) {           
            if (this.countries[i].code2 == code) {                
                return true;
            }
        }
        return false;
    }

    /**
     * Get country name by code
     * @param code 2-letter code
     */
    get2CountryCodeName(code) {
        for (let i = 0; i < this.countries.length; i++) {           
            if (this.countries[i].code2 == code) {
                return this.countries[i].name;
            }
        }
        return "";
    }

    /**
     * Get several country names seperated by semi colonn
     * @param codes Semi colonn seperated with code2
     */
    get2CountryCodeNames(codes: any) {
        let countryStr = "";
        if (codes != null) {
            let countryCodes = codes.split(",");        
            for(let i = 0; i < countryCodes.length; i++) {            
                countryStr += this.get2CountryCodeName(countryCodes[i]) + ", ";
            }
            return countryStr.slice(0, -2);
        }
        return "";
    }

    /**
     * Get country name by code
     * @param code 3-letter code
     */
    get3CountryCodeName(code) {
        for (let i = 0; i < this.countries.length; i++) {
            if (this.countries[i].code3 == code) {
                return this.countries[i].name;
            }
        }
        return "None";
    }

    /**
     * Get country by name
     * @param name country name
     */
    getCountryFromName(name) {
        if(name != null && name.length > 0){
            let country = this.countries.find(country => country.name.toLocaleLowerCase() === name.toLocaleLowerCase())
            return country;
        } else {
            return null;
        }
    }    

    /**
     * Get employer country name by code
     * @param code 2-letter code
     */
     get2EmployerCountryCodeName(code) {
        for (let i = 0; i < this.employerCountries.length; i++) {
            if (this.employerCountries[i].code2 == code) {
                return this.employerCountries[i].name;
            }
        }
        return "";
    }

    /**
     * Get employer country name by code
     * @param code 3-letter code
     */
    get3EmployerCountryCodeName(code) {
        for (let i = 0; i < this.employerCountries.length; i++) {
            if (this.employerCountries[i].code3 == code) {
                return this.employerCountries[i].name;
            }
        }
        return "None";
    }

    /**
     * Get employer country by name
     * @param name country name
     */
    getEmployerCountryFromName(name) {
        if(name != null && name.length > 0){
            let country = this.employerCountries.find(country => country.name.toLocaleLowerCase() === name.toLocaleLowerCase())
            return country;
        } else {
            return null;
        }
    }

    constructor() {
        this.countries = countriesJson.countries;       
        this.employerCountries = countriesJson.employerCountries;     
        
        this.countries.sort((a, b): number => {
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
        });

        this.employerCountries = [...this.employerCountries, ...this.countries]
    }
}